import { Link,  generatePath, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

function FailurePage() {
    const { clientNameParam } = useParams();
  
  return (
    <div style={{ textAlign: "center", marginTop: "70px" }}>
      <FontAwesomeIcon
        icon={faCircleXmark}
        style={{ color: "#f23636", fontSize: "5rem", marginBottom: "2rem" }}
      />
      <h1>Payment Cancelled!</h1>
      <p style={{ marginBottom: "35px" }}>
        Your transaction was not completed. Please try again or contact support if any issue persists.
      </p>
      <Link to={generatePath("/client/:clientNameParam/clientDashboard", {
                                  clientNameParam,
                                })} className="btn btn-primary">
        Go to Dashboard
      </Link>
    </div>
  );
}

export default FailurePage;
